<template>
  <div class="scheduleTable">
    <div class="header">
      <span class="hospitalName">{{ scheduleList.hospital }}</span>
      <span class="departmentName">
        {{ `${scheduleList.departmentName} | 挂号费${scheduleList.amRegistrationFee}元` }}
      </span>
      <span class="tips">* 挂号费以到院支付为准</span>
    </div>
    <!-- 排班表 -->
    <div class="stable" v-for="(listItem, listIndex) in list" :key="listIndex">
      <div class="title">
        <div>日期</div>
        <div>上午</div>
        <div>下午</div>
      </div>
      <div class="content" v-for="(item, index) in listItem" :key="index">
        <!-- 日期和星期 -->
        <div class="titleBgc box">
          <div class="week">{{ item.week }}</div>
          <div>{{ item?.shiftScheduleDate?.substring(5) }}</div>
        </div>
        <!-- 渲染上下午排班单元格 -->
        <ScheduleTableCell
          :type="typeItem"
          v-for="typeItem in ['am', 'pm']"
          :key="typeItem"
          :data="{
            doctorScheduleDayVO: item?.doctorScheduleDayVO,
            shiftScheduleDate: item?.shiftScheduleDate,
            week: item?.week
          }"
          @handleSelect="handleSelect"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { getScheduling } from '@/api/Todo'
import { ref, defineProps, defineEmits, watch } from 'vue'
import ScheduleTableCell from './ScheduleTableCell.vue'

const props = defineProps({
  scheduleList: {
    type: Object,
    default: () => ({})
  }
})
const emit = defineEmits(['handleSelect'])
const list = ref([])

watch(
  () => props.scheduleList.doctorScheduleVOList,
  val => {
    const newData = [val?.slice(0, 7), val?.slice(7)]
    list.value = newData
  },
  { deep: true, immediate: true }
)

// 选择排班 查看号源
const handleSelect = val => {
  const selectData = {
    ...val,
    departmentName: props.scheduleList.departmentName
  }
  emit('handleSelect', selectData)
}

console.log(props.scheduleList)
</script>

<style scoped lang="scss">
.scheduleTable {
  margin-bottom: 16px;
  .header {
    display: flex;
    align-items: center;
    background: url('../../../assets/img/register/schedule-header.png') no-repeat center;
    background-size: 100% 100%;
    height: 48px;
    padding: 16px 24px;
    background-color: #1890ff;
    .hospitalName {
      font-weight: 700;
      font-size: 16px;
      color: #fff;
      margin-right: 67px;
    }
    .departmentName {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.9);
      margin-right: 12px;
    }
    .tips {
      margin-top: 2px;
      font-size: 10px;
      color: rgba(255, 255, 255, 0.9);
    }
  }
  .stable {
    display: flex;
    .title {
      font-weight: 700;
      font-size: 14px;
      color: #595959;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #eff4fa;
        width: 184px;
        height: 58px;
        border-radius: 4px;
        margin: 2px 1px;
      }
    }
    .content {
      font-size: 12px;
      color: #595959;
      .box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: center;
        width: 182.5px;
        height: 58px;
        border-radius: 4px;
        margin: 2px 1px;
      }
      .week {
        font-weight: 700;
        font-size: 14px;
        color: #595959;
      }
    }
  }
  .titleBgc {
    background-color: #eff4fa;
  }
  .numberBgc {
    border: 1px solid #f0f0f0;
  }
  .order {
    color: #1890ff;
    font-size: 14px;
  }
}
</style>
